import React from 'react';
import { FaTruck, FaHeadset, FaGem, FaShieldAlt } from 'react-icons/fa';
import './FeatureSection.css';

const features = [
  {
    id: 1,
    icon: FaGem,
    title: 'Premium Quality',
    description: '24K gold plated & sterling silver imitation jewellery'
  },
  {
    id: 2,
    icon: FaTruck,
    title: 'Fast Delivery',
    description: 'Free shipping on orders above ₹5000'
  },
  {
    id: 3,
    icon: FaShieldAlt,
    title: 'Secure Payment',
    description: '100% secure • Cards, UPI, Net Banking'
  },
  {
    id: 4,
    icon: FaHeadset,
    title: 'Customer Support',
    description: 'Available Monday to Saturday • 10 AM - 7 PM'
  }
];

const FeatureSection = () => {
  return (
    <section className="feature-section">
      <div className="feature-grid">
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <div key={feature.id} className="feature-item">
              <div className="feature-icon">
                <Icon />
              </div>
              <div className="feature-content">
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeatureSection;